import { componentLoader } from '@/tools/blockLoader';
import { actionTypes, mutationTypes, getterTypes } from '@/types';
import setMediaObjectsSources from '@/tools/setMediaObjectsSources';

import Vue from 'vue';
export default {
	state: {
		name: undefined,
		content: null,
		mediaObjects: [],
		active: false,
		blocksUrl: null,
		blocksDevHash: null,
	},

	mutations: {
		setEditorApiContent(state, { content, articleName }) {
			state.content = content;
			state.name = articleName;
		},
		addEditorApiContent(state, { content }) {
			state.content = { ...state.content, ...content };
		},
		updateEditorApiContentElement(state, { elements }) {
			elements.forEach((element) => {
				if (!element?.id) return;
				Vue.set(state.content, element.id, element);
				// state.content[element.id] = element;
			});
		},
		[mutationTypes.setEditorApiActive](state, active) {
			state.active = active;
		},
		[mutationTypes.setBlocksUrl](state, blocksUrl) {
			state.blocksUrl = blocksUrl;
		},
		[mutationTypes.setBlocksDevHash](state, blocksDevHash) {
			state.blocksDevHash = blocksDevHash;
		},
		[mutationTypes.forceEditorApiContentReload](state) {
			if (state.content?.elements) {
				Vue.set(state.content, 'elements', [...state.content.elements]);
			}
		},
	},
	actions: {
		setEditorApiContent({ commit }, payload) {
			commit('setEditorApiContent', payload);
		},
		addEditorApiContent({ commit }, payload) {
			commit('addEditorApiContent', payload);
		},
		updateEditorApiContentElement({ commit }, payload) {
			commit('updateEditorApiContentElement', payload);
		},

		[actionTypes.initEditorApi]({ commit, dispatch, rootState }) {
			commit(mutationTypes.setEditorApiActive, true);
			window.addEventListener(
				'message',
				(event) => {
					if (event.data.type === 'editor') {
						if (event.data.message === 'content') {
							if (event.data.articleId) {
								commit(mutationTypes.setArticleID, { article: event.data.articleId });
							}
							dispatch('setEditorApiContent', {
								content: event.data.content,
								articleName: event.data.articleName,
							});
						}
						if (event.data.message === 'update') {
							// console.log('Webclient: Update Received!');
							dispatch('updateEditorApiContentElement', {
								elements: event.data.elements,
							});
						}
						if (event.data.message === 'mediaObjects') {
							dispatch(actionTypes.addToMediaObjectMap, {
								mediaObjectArray: setMediaObjectsSources(
									Object.values(event?.data?.mediaObjects || {}),
									rootState.dataSourceURL
								),
							});
						}
						if (event.data.message === 'language') {
							dispatch(actionTypes.setLanguage, { language: event.data.language.name });
						}
					}
				},
				false
			);
			parent.postMessage({ type: 'webclient', message: 'loaded' }, '*');
		},
		[actionTypes.initBlocksDevServer]({ commit }, url) {
			commit(mutationTypes.setBlocksUrl, url);
			const _url = new URL(url);
			const devSocket = new WebSocket(
				(_url.protocol === 'https:' ? 'wss://' : 'ws://') + _url.host + '/sockjs-node/173/00uxdc55/websocket'
			);

			devSocket.onmessage = async (event) => {
				if (/^a\[.*\]$/.test(event.data)) {
					const message = JSON.parse(JSON.parse(event.data.slice(2, event.data.length - 1)));
					if (message.type === 'hash') {
						componentLoader.clearCache();
						commit(mutationTypes.setBlocksDevHash, message.data);
						commit(mutationTypes.forceEditorApiContentReload);
					}
				}
			};
		},
	},
	getters: {
		[getterTypes.getBlocksDevHash](state) {
			return state.blocksDevHash;
		},
		getEditorIsActive(state) {
			return state.active;
		},
		getEditorContent(state) {
			return state.content;
		},
	},
};
